import { getDefaultCountry } from "../../shipping/utils/getDefaultCountry.js";
import { sanitizeText } from "../index.js";
export const getAddressesFromInput = (addresses, email) => {
    const sanitizedEmail = email ? sanitizeText(email) : undefined;
    const billingAddress = addresses.billing
        ? {
            ...addresses.billing,
            type: "billing",
            country: getDefaultCountry(),
            email: sanitizedEmail,
        }
        : undefined;
    const deliveryAddress = addresses.delivery
        ? {
            ...addresses.delivery,
            type: "delivery",
            country: getDefaultCountry(),
            email: sanitizedEmail,
        }
        : undefined;
    return [billingAddress, deliveryAddress].filter(Boolean);
};
